import {
  Component,
  forwardRef,
  Inject,
  Input
} from '@angular/core';

import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { HaynesProService }          from './haynes-pro.service';
import { HaynesProVehicleInfoModel } from './typings/haynes-pro.vehicle-info';
import { Table }                     from '../table/types/table';
import { VehicleModel }              from '../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-vehicle-selection',
  template: require('./haynes-pro.vehicle-selection.component.html')
})
export class HaynesProVehicleSelectionComponent {
  public selectedVehicle ?: HaynesProVehicleInfoModel;
  public tableSettings    : Table = {
    columns: [
      {
        field : 'full_name',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.FULL_NAME')
        }
      },
      {
        field : 'engine_code',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.ENGINE_CODE')
        }
      },
      {
        field : 'fuel_type',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.FUEL_TYPE')
        },
      },
      {
        field : 'power',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.POWER')
        }
      },
      {
        field : 'capacity',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.CAPACITY')
        }
      },
      {
        field : 'made_from',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.MADE_FROM')
        }
      },
      {
        field : 'made_until',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.MADE_UNTIL')
        }
      },
      {
        field : 'variant_code',
        header: {
          text: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.VARIANT_CODE')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND')
    },
    pagination: {
      enabled: false
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
    static: true
  };

  @Input() vehicle : VehicleModel;
  @Input() vehicles: Array<HaynesProVehicleInfoModel>;

  constructor (
    public activeModal       : NgbActiveModal,
    @Inject(forwardRef(() => HaynesProService))
    public haynesProService  : HaynesProService,
    public  translateService : TranslateService
  ) {}

  confirmSelection ( vehicle : HaynesProVehicleInfoModel = this.selectedVehicle ) : void {
    this.vehicle.haynes_pro_vehicle_id = vehicle.id;

    this.activeModal.close(this.vehicle);
  }

  handleSelection ( vehicle : HaynesProVehicleInfoModel ) : void {
    this.selectedVehicle = vehicle.selected
      ? vehicle
      : null;
  }

}
